import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { skeletonPulseStyle } from './Skeleton.css';

type Props = ComponentPropsWithRef<'div'>;

export const Skeleton = ({ children, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(skeletonPulseStyle, delegated.className)}>
      {children}
    </div>
  );
};
